// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2929":"9e5544203774da6b","10877":"1c73507c785b0a55","19188":"c90a9aafffb5b66e","67615":"18c49a5149530a7d","82991":"440766797b3e56ec"}[chunkId] + ".css";
};